<template>
  <div id="app">
    <screen-fit v-if="$route.meta && $route.meta.screenFit">
      <router-view/>
    </screen-fit>
    <router-view v-else/>
  </div>
</template>

<script>
import ScreenFit from "@/components/ScreenFit.vue";

export default {
  name: "App",
  components: {
    ScreenFit
  }
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 16px; // 设置基准字体大小
  overflow-x: hidden;
}

body {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;
  min-height: 100vh;
  font-family: Microsoft YaHei, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  overflow-x: hidden;
}
</style>
